'use client'
import { FC, useCallback, useMemo } from 'react'
import { AccountPageStd } from 'storefront-modules/account'
import { useSlideOut } from '#/src/custom/controllers'
import { useRouter } from 'next/navigation'
import { useUser } from 'auth'
import { OrderDTO } from 'ecosystem'
import { AccountPageConfig } from 'storefront-modules/account/components/AccountPageStd'

interface AccountPageComponentProps {}

const AccountPageComponent: FC<AccountPageComponentProps> = () => {
  const { openSlideOut } = useSlideOut()
  const router = useRouter()

  const { user } = useUser({ redirectTo: '/login' })

  const onLogout = useCallback(async () => {
    router.push('/login')
  }, [router])

  const onOpenOrderDetail = useCallback(
    async (orderDetail: OrderDTO) => {
      openSlideOut({
        componentId: 'customerOrderDetail',
        title: orderDetail.orderNumber || '-',
        extraArgs: {
          order: orderDetail
        },
        drawerProps: {
          placement: 'right',
          size: 'md'
        }
      })
    },
    [openSlideOut]
  )

  const config: AccountPageConfig = useMemo(() => {
    return {
      paths: {
        getOrders: '/api/account/orders',
        updateCustomer: '/api/account/update',
        getOrderDetail: '/api/account/order-detail',
        logout: '/api/auth/logout',
        resetPassword: '/api/auth/reset-password'
      },
      userGreeting: `Välkommen: ${user?.customer?.email || ''}`,
      onLogout,
      onOpenOrderDetail
    }
  }, [onLogout, onOpenOrderDetail, user?.customer?.email])

  return <AccountPageStd {...{ config }} />
}

export default AccountPageComponent
